const routes = [
  {
    path: '',
    component: () =>
      import('@/views/provider/billingHistory/BillingHistoryWrapper.vue'),
    children: [
      {
        path: '/provider/billingHistory',
        name: 'BillingHistory',
        component: () =>
          import('@/views/provider/billingHistory/BillingHistory.vue'),
      },
      {
        path: '/provider/billingDetails/:billId',
        name: 'BillingDetails',
        component: () =>
          import('@/views/provider/billingHistory/BillingDetails.vue'),
      },
      {
        path: '/provider/visitRegistry/validateVisit',
        name: 'VisitRegistryValidateFromBilling',
        component: () =>
          import('@/views/provider/visitRegistry/VisitValidation.vue'),
      },
      {
        path: '/provider/trainingDetail/:id',
        name: 'TrainingDetailsFromBilling',
        component: () =>
          import('@/views/provider/trainingHistory/TrainingDetails.vue'),
        props: true,
      },
    ],
  },
];

export default routes;
